














import {
	computed,
	defineComponent,
	PropType,
	watch,
} from '@vue/composition-api';
import DenseUserList from '@front-app/components/cards/DenseUserList.vue';
import LoaderState from '@front-app/components/LoaderState.vue';
import { UserStore } from '@front-app/store/singletons/User';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { Size } from '@front-app/components/constants';

export default defineComponent({
	components: { LoaderState, DenseUserList },
	props: {
		speakerIds: {
			type: Array as PropType<string[]>,
			required: true,
		},
	},
	setup(props) {
		const userStore = UserStore.getInstance();
		const { track, isLoading } = useAsyncStatus();
		watch(() => props.speakerIds, (curr) => {
			track(userStore.fetchMany(curr));
		}, { immediate: true });
		const speakers = computed(() => props.speakerIds.map((id) => userStore.getPartial(id).value));
		return {
			isLoading,
			speakers,
			speakersLoaderSize: Size.SMALL,
		};
	},
});
